import React from 'react';
import { motion } from 'framer-motion';

/**
 * FadeIn Animation Component
 * Fades in content when it mounts or becomes visible
 */
const FadeIn = ({ 
  children, 
  delay = 0, 
  duration = 0.5, 
  direction = 'up',
  distance = 30,
  ...props 
}) => {
  const directions = {
    up: { y: distance },
    down: { y: -distance },
    left: { x: distance },
    right: { x: -distance },
  };

  const slideOffset = directions[direction] || { y: distance };

  return (
    <motion.div
      initial={{ 
        opacity: 0, 
        ...slideOffset 
      }}
      animate={{ 
        opacity: 1, 
        x: 0, 
        y: 0 
      }}
      transition={{ 
        duration, 
        delay,
        ease: [0.25, 0.4, 0.25, 1] // Custom easing
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
